var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('greet'),_c('red-separator'),_c('screenshots'),_c('features'),_c('play'),_c('micro-blog'),_c('subscription')],1)}
var staticRenderFns = []

export { render, staticRenderFns }